import React from 'react';
import {observer} from 'mobx-react';
import './inner-content.scss';
import {displayItemGridLines} from '../grid-line/display-item-grid-line';
import {DisplayTypeEnum} from '../render-v2-d';
import {documentImageSizeStyle, nonDocImageSizeStyle} from '../document-dimensions/document-dimensions';
import {MatSecondary} from '../mat-secondary/mat-secondary';
import {Spirit} from '../spirit/spirit';
import {FrameBuilderStore} from '../frame-builder-store';
import {innerContentSideRailStyle} from './side-rails/inner-content-side-rails';

type Props = {
    maxCols: number;
    width: number;
    height: number;
    store: FrameBuilderStore;
};

export const InnerContent = observer(({store, maxCols, width, height}: Props) => {
    const {frame, inchToPx} = store;
    const {moulding} = frame;

    return (
        <div
            id="inner-content"
            style={{
                gridTemplateColumns: `repeat(${maxCols}, auto)`,
                gridTemplateRows: `${store.itemsCount(DisplayTypeEnum.Insignia) > 0 ? inchToPx(frame.railTop) : ''} ${store.isVertical ? `repeat(${store.itemsCount(DisplayTypeEnum.Doc)}, 1fr)` : '1fr'} ${store.itemsCount(DisplayTypeEnum.Lino) > 0 ? inchToPx(frame.railBottom) : ''}`,
                justifyContent: 'center',
                inset: `${inchToPx(moulding.mouldingThickness)}`,
                width: inchToPx(width),
                height: inchToPx(height),
                paddingTop: !store.itemsCount(DisplayTypeEnum.Insignia) ? inchToPx(frame.railTop) : '',
                paddingBottom: !store.itemsCount(DisplayTypeEnum.Lino) ? inchToPx(frame.railBottom) : '',
                ...innerContentSideRailStyle(frame.railLeft, frame.railRight, inchToPx),
            }}
        >
            {frame.displayMatrix.map((row, rIdx) =>
                row.map((item, cIdx) => {
                    if (!item) return null;

                    const isDoc = item.displayType === DisplayTypeEnum.Doc;
                    const sizeStyle = isDoc ? documentImageSizeStyle(item, inchToPx) : nonDocImageSizeStyle(item, inchToPx);

                    return (
                        <div
                            key={`${rIdx}-${cIdx}`}
                            style={{
                                ...displayItemGridLines(item),
                                marginRight: inchToPx(store.gapAfterItemColumn(item)),
                                marginBottom: inchToPx(store.gapAfterItemRow(item)),
                                // A SingleDoc opening reserves the document's size and draws no image.
                                ...(!item.url && isDoc ? sizeStyle : {}),
                            }}
                            className="inner-container"
                        >
                            {isDoc && (item.mat2Color || item.mat2ImageURL) ? (
                                <MatSecondary
                                    item={item}
                                    store={store}
                                />
                            ) : item.url ? (
                                <img
                                    src={item.url}
                                    alt={item.displayType}
                                    style={sizeStyle}
                                />
                            ) : null}
                        </div>
                    );
                }),
            )}

            {frame.spiritMode && <Spirit store={store} />}
        </div>
    );
});
